import React, { useEffect, useRef, useState } from 'react';
import './Product.css';

const OffsetImprime = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const galleryImages = [
    '/images/papier_offset/1.jpg',
    '/images/papier_offset/2.jpg',
    '/images/papier_offset/3.jpg',
    '/images/papier_offset/4.jpg',
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="product light-blue-bg" ref={sectionRef}>
      <div className="product-container">
        <div className="product-layout">
          {/* Product Description */}
          <div className={`product-text ${isVisible ? 'fade-in' : ''}`}>
            <h2 className="product-title">Papier Offset Imrpimé</h2>
            <p>
            Nos papiers pour l'impression offset offrent une fluidité exceptionnelle, sèchent rapidement et produisent des résultats d'impression remarquables. Notre portefeuille de produits répond à presque toutes les exigences de l'impression offset et offre un plus grand choix en matière d'applications et de finitions. Les performances de nos papiers ont été testées en profondeur pour garantir un avantage concurrentiel et des résultats d'impression constants pour donner de valeurs a vos produits 
            </p>
          </div>

          {/* Image Gallery */}
          <div className={`product-gallery ${isVisible ? 'fade-in-delay' : ''}`}>
            <div className="gallery-grid">
              {galleryImages.map((image, index) => (
                <div key={index} className="gallery-item">
                  <img src={image} alt={`Coffret à oreilles ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OffsetImprime;